import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import BestPostageMetersWrapper from "@components/layouts/bestpostagemetersWrapper";

import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function BestPostageMetersHome(): ReactElement {
    return (
        <BestPostageMetersWrapper>
            <TermsAndConditions
                category="Postage Meters"
                domain="BestPostageMeters.com"
            />
        </BestPostageMetersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
